import { AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import NotificationItem from "./NotificationItem";

interface NotificationListProps {
  notifications: any[];
  loading: boolean;
  onMarkAsRead: (id: string) => void;
  onRemove: (id: string) => void;
}

const NotificationList = ({ notifications, loading, onMarkAsRead, onRemove }: NotificationListProps) => {
  const { t } = useTranslation();

  const activeNotifications = notifications.filter((n: any) => n.isActive !== false);

  if (activeNotifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700">
          <svg className="h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5zM4 19h6v-6H4v6z" />
          </svg>
        </div>
        <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">
          {t("admin.notifications.noNotifications")}
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t("admin.notifications.noNotificationsDescription")}
        </p>
      </div>
    );
  }

  return (
    <div className="max-h-96 overflow-y-auto py-1">
      <AnimatePresence>
        {activeNotifications.map((notification: any) => (
          <NotificationItem
            key={notification._id}
            notification={notification}
            onMarkAsRead={onMarkAsRead}
            onRemove={onRemove}
            loading={loading}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default NotificationList;

